module.exports = __webpack_public_path__ + "media/images/expand-icon-719bce37f76e2cf6bb1ccbae0c44e54a8a58562a2b43972e3356ee099b78b5e5.svg";